module.exports = __webpack_public_path__ + "static/3A841E_0_0-48b2f27e49fac52791682a771c69d8e7.svg";